import settingsReducer from "../slices/settingsSlice";
import orderReducer from "../slices/orderSlice";
import tableReducer from "../slices/tableSlice";
import archiveReducer from "../slices/archiveScheduleSlice";
import syncScheduleReducer from "../slices/syncScheduleSlice";
import schemaReducer from "../slices/schemaSlice";
import archiveSlice from "../slices/archiveSlice";
import dbReducer from "../slices/dbSlice";
import dbSwitchReducer from "../slices/dbSwitchSlice";
import deleteOrdersReducer from "../slices/deleteOrdersSlice";
import logReducer from "../slices/logSlice";
import bgProcessReducer from "../slices/bgProcessSlice";

const rootReducer = {
    reducer:{
        orders:             orderReducer,
        settings:           settingsReducer,
        getTables:          tableReducer,
        archiveSchedule:    archiveReducer,
        syncSchedule:       syncScheduleReducer,
        schema:             schemaReducer,
        archive:            archiveSlice,
        database:           dbReducer,
        dbSwitch:           dbSwitchReducer,
        deleteOrders:       deleteOrdersReducer,
        logs:               logReducer,
        backgroundProcess:  bgProcessReducer,
    },
}

export default rootReducer;